import { ReactNode, useEffect } from 'react';
import { Box, styled } from '@mui/material';

export const DARK_BACKGROUND_GRADIENT =
  'linear-gradient(112deg, #0D212D -1.48%, #193D50 100.88%)';

interface DarkPageLayoutProps {
  children: ReactNode;
  summaryCards?: ReactNode;
}

export const DarkPageLayout = ({
  children,
  summaryCards,
}: DarkPageLayoutProps) => {
  useEffect(() => {
    const mainContent = document.querySelector(
      '[data-testid="main-content"]',
    ) as HTMLElement;
    if (mainContent) {
      mainContent.style.backgroundImage = DARK_BACKGROUND_GRADIENT;
    }
    return () => {
      if (mainContent) {
        mainContent.style.backgroundImage = '';
      }
    };
  }, []);

  return (
    <Container>
      {summaryCards && (
        <SummaryCardsSection>{summaryCards}</SummaryCardsSection>
      )}
      <ContentSection>{children}</ContentSection>
    </Container>
  );
};

const Container = styled(Box)`
  display: flex;
  flex-direction: column;
  height: 100%;
  background-image: ${DARK_BACKGROUND_GRADIENT};
  overflow: hidden;
`;

const SummaryCardsSection = styled(Box)`
  padding: 24px 32px;
  flex-shrink: 0;
`;

const ContentSection = styled(Box)`
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;
  padding: 0 32px;
`;
